import React, { PropTypes } from 'react'

import './SearchSummary.scss'

const SearchSummary = ({ searchResults, searching, typeId }) => {
  let bookingName
  typeId = parseInt(typeId)
  switch (typeId) {
    case 1:
    case 5:
    case 6:
      bookingName = 'recurrencia'
      break
    case 2:
    default:
      bookingName = 'servicio'
  }
  return (
    <p className='SearchSummary'>
      {
        searching
          ? 'Buscando entre miles de Aliadas'
          : `Encontramos ${searchResults.length} Aliada${searchResults.length === 1 ? '' : 's'} para tu ${bookingName}`
      }
    </p>
  )
}

SearchSummary.displayName = 'SearchSummary'
SearchSummary.propTypes = {
  searchResults: PropTypes.array.isRequired,
  searching: PropTypes.bool.isRequired,
  typeId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired
}

export default SearchSummary



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/ChangeAliadaSearchBase/components/SearchSummary/SearchSummary.js